module.exports = __webpack_public_path__ + "media/images/icons/mail_icon-5be83ea5084572df546b43a53df66a8f.svg";